export class AngleNumbers {
  public static readonly elbowLeft: number = 0;
  public static readonly elbowRight: number = 1;
  public static readonly kneeLeft: number = 2;
  public static readonly kneeRight: number = 3;
  public static readonly shoulderLeft: number = 4;
  public static readonly shoulderRight: number = 5;
  public static readonly torso: number = 6;
  public static readonly ankleLeft: number = 7;
  public static readonly ankleRight: number = 8;
  public static readonly hipLeft: number = 9;
  public static readonly hipRight: number = 10;
  public static readonly wristLeft: number = 11;
  public static readonly wristRight: number = 12;
  public static readonly neck: number = 13;
  public static readonly stick: number = 14;
  public static readonly average: number = 15;
  public static readonly numberOfAngles: number = AngleNumbers.average + 1;
}
